import React from 'react';
import { connect } from 'dva';
import { framework_tool,utils_tool,component_tool } from '@/tool'
import { templateConfig, reduxTemplateCofig } from './config'
const { WizContainer, WizReduxTemplate } = framework_tool;
let {  WizBrowserExport } = component_tool;
let { Session } = utils_tool;
const _getValue = (type, key)=> {
  const values = {
    jobState: {
      0: '离职',
      1: '在职',
    },
    dealerState: {
      0: '已关店',
      1: '已开店',
      2: '建设中',
    },
    userType: {
      0: '培训平台用户',
      3: 'OEM部门用户',
      4: '经销商用户',
      5: '服务商用户'
    },
    state: {
      1: '激活',
      0: '禁用',
    },
    channel: {
      0: '系统',
      1: '企业号',
      2: 'DP',
      3: '新能源',
    },
  }
  return values[type][key]
}

class PersonManage extends WizContainer {

  componentName = 'PersonManage';

  constructor(props) {
    super(props);
    this.state = {
    }
    const { history } = props;
    let searchProps = {};
    if (history.location && history.location.pathname === '/org/dealer/lookPositionNumber') {
      if (history.location && history.location.record) {
        searchProps = history.location.record;
        Session.set('searchProps', searchProps)
      } else {
        searchProps = Session.get('searchProps') || {};
      }
    }
    this.searchProps = searchProps;
  }

  _handleIdentityFile(nextProps, nextState, key) {
    let response = nextProps[key]
    const blob =response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = "人员任职信息.xls";

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);

    window.URL.revokeObjectURL(link.href);
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      /* {
        headerName: '证件号码',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }, */
      {
        headerName: '邮箱',
        field: 'email',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '用户属性',
        field: 'userType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号状态',
        field: 'state',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '数据来源',
        field: 'channel',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '入职时间',
        field: 'hireTime',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '最新修改时间',
        field: 'updateTime',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = Object.assign([],o['data'])
      data.forEach((val, index) => {
        val['userType'] = _getValue('userType',val['userType'])
        val['state'] = _getValue('state',val['state'])
        val['channel']  = _getValue('channel',val['channel'])
        if(val['mobile'] !== ''&& val['mobile'] !== null && val['mobile'] !== undefined) {
        val['mobile'] = val['mobile'].replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
        }
      })
      WizBrowserExport({
        title: '人员信息',
        sheetName: '人员信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '人员信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleRandomPersonInfo(nextProps, nextState, key) {

    let response = nextProps[key]
    const blob =response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = "人员信息.xls";

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);

    window.URL.revokeObjectURL(link.href);
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _batchChangeState(nextProps, nextState, key) {
    let o = nextProps[key] || {}
    let {code, success, msg, data} = o
    if (success) {
      wizNotice.success({
        duration: 4.5,
        message: <div dangerouslySetInnerHTML={{__html: data && JSON.stringify(data) !== '{}' ? data : msg}}/>
      })
      return true;
    } else {
      wizNotice.error(msg)
      return false;
    }
  }

  _list(nextProps, nextState, key) {
    let o = nextProps[key] || {}
    let {code, success, msg, data} = o
    if (success) {
      let list = data.records;
      let listNew = []
      list && list.length && list.forEach(element => {
        if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
            element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
          }
        listNew.push(element);
    });
    return listNew;
    } else {
      wizNotice.error(msg)
      return false;
    }
  }

  /**
   * 当作为二级页面展示时，接收参数及修改一些配置
   */
  _getPushProps = () => {
    let { location } = this.props;
    let searchProps = location['record'] && location['record'] && location['record']['searchProps'] ? location['record']['searchProps'] : undefined
    if (!searchProps) {
      searchProps = this.searchProps['searchProps'];
    }
    let btnAccessCheck = searchProps ? false : true
    let templateConfigProps = { searchProps, btnAccessCheck }
    let apiProps = {}
    if ((searchProps && searchProps['org'] && searchProps['org'].length)) {
      let org = searchProps['org'][0]
      apiProps = {
        organizationIdList: [org['orgId']],
        keepInitApiParams: true
      }
    }
    return { templateConfigProps, apiProps }
  } 

  _render() {
    let pushProps = this._getPushProps()
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({ ...pushProps['templateConfigProps'] }),
      apiDataFormat: {
        enable: this._handleCMD,
        reset: this._handleCMD,
        personInfoExport: this._handleFile,
        personIdentityInfoExport: this._handleIdentityFile,
        personInfoExportRandomNumber: this._handleRandomPersonInfo,
        batchChangeState: this._batchChangeState,
        list: this._list,
      },
      ...pushProps['apiProps']
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(PersonManage);
